import React, { useEffect, useRef, useState } from 'react';
import * as dateFns from 'date-fns';

import WeekHeader from './WeekDaysHeader';
import Loader from '../../../Shared/Loader';
import Days from '../Day/Days';
// import PracticeModalOld from '../../../../containers/Schedule/PracticeModalOld';
import { useInterval, useRouter } from '../../../../helpers/customHooks';
import { LOAD_TODAY_EVENTS_TIME_SCHEDULE } from '../../../../config/constants';
import { routeToDate, routeToScheduleScope } from '../../../../helpers';
import { useEventsDispatch, useEventsState } from '../../../../store/hooks/events';

export default ({ selectedDate = new Date() }) => {
  
  const { pathname } = useRouter();
  const pathOnlyDate = pathname.split('/').slice(0, 6).join('/');
  const scheduleScope = routeToScheduleScope(pathOnlyDate);
  const events = useEventsState(pathOnlyDate);
  const { loadEvents } = useEventsDispatch();
  const [indexAddButton, setIndexAddButton] = useState(-1);
  useEffect(loadEvents(true, undefined, undefined, true), [scheduleScope, events]);
  useInterval(loadEvents(false, true), LOAD_TODAY_EVENTS_TIME_SCHEDULE);
  const viewport = useRef<HTMLDivElement>(null);
  const [disableScrollTop, setDisableScrollTop] = useState(false);
  const today = new Date();
  useEffect(() => {
    if (viewport.current && !disableScrollTop) {
      viewport.current.scrollTop = ((((dateFns.getHours(today) * 60) + dateFns.getMinutes(today)) * 1.1) - (66 * 3) - 2);
    }
  });
  
  // const pathnames = pathname.split('/');
  // let [modal, setModal] = useState(pathnames[7] ?
  //   <PracticeModalOld gameId={pathnames[7]} closeModal={() => setModal(null)} /> : null);
  // useEffect(() => {
  //   setModal(pathnames[7] ? <PracticeModalOld gameId={pathnames[7]} closeModal={() => setModal(null)} /> : null);
  // }, [pathname]);
  const selectedWeek = routeToDate(pathOnlyDate);
  
  return (
    <div className="calendar" onMouseLeave={event => setIndexAddButton(-1)}>
      <WeekHeader indexAddButton={indexAddButton} />
      <div className="schedule-c p-01" ref={viewport} onScroll={() => (setDisableScrollTop(true))}>
        <Loader>
          <div className='body'>
            <Days
              selectedWeek={selectedWeek}
              selectedDate={selectedDate}
              events={events}
              setIndexAddButton={setIndexAddButton} />
          </div>
        </Loader>
      </div>
      {/*{modal}*/}
    </div>
  );
};
